import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Breadcrumbs from "@/components/Breadcrumbs";
import BackToTop from "@/components/BackToTop";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import { isChromelessRoute } from "@/lib/chromeless";

/**
 * Renders the global chrome (navbar, breadcrumbs, back-to-top)
 * everywhere EXCEPT inside the admin area, which has its own layout, and on
 * the chromeless routes (the /lp campaign page), which are deliberately
 * navigation-free.
 */
export const AppChromeTop = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin") || isChromelessRoute(pathname)) return null;
  return (
    <>
      {/* Above the navbar so it reads as a site-wide notice rather than page content. */}
      <AnnouncementBanner />
      <Navbar />
      <Breadcrumbs />
    </>
  );
};

export const AppChromeBottom = () => {
  const { pathname } = useLocation();
  // /lp has its own sticky call to action pinned to the same corner; two
  // floating buttons fighting for it is how the CTA gets missed.
  if (pathname.startsWith("/admin") || isChromelessRoute(pathname)) return null;
  return <BackToTop />;
};
